<template>
  <v-dialog v-model="dialog" max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :disabled="!(hasPermission || hasGooglePermission)" :outlined="hasPermission" color="primary">
        「送出」過去評價的AI回覆
      </v-btn>
    </template>

    <v-card class="pa-4" :loading="loading" :disabled="loading">
      <v-btn
        fab
        icon
        absolute
        width="48"
        height="48"
        style="top: 0; right: 0; overflow: hidden;"
        @click="dialog = false;"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title class="text-center d-block">
        {{ title }}
      </v-card-title>
      <v-card-subtitle class="red-6--text text-center">
        {{ errorMsg }}
      </v-card-subtitle>
      <v-card-text v-show="step === 1">
        <v-checkbox
          v-model="selectType"
          label="站內評價"
          :value="1"
          hide-details="auto"
          hint="點擊確定後，評價回覆會送出，但不會通知病患。"
          persistent-hint
          :disabled="!hasPermission"
        />
        <v-checkbox
          v-model="selectType"
          label="Google商家評價"
          :value="2"
          hide-details="auto"
          hint="點擊確定後，會實際送出到診所 google 商家上，且病患會收到 google 的通知。"
          persistent-hint
        />
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" class="px-8" @click="confirm">{{ step === 1 ? '確定選擇' : '確定送出' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { submitPastAiResponseAPI } from "@/api";
import { mapGetters } from "vuex";

export default {
  name: 'SendAiResponseDialog',

  props: {
    hasPermission: {
      type: Boolean,
      default: false
    },
    hasGooglePermission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialog: false,
      selectType: [],
      title: '請選擇欲送出AI回覆的評價類型',

      step: 1,
      loading: false,

      errorMsg: ''
    };
  },

  computed: {
    ...mapGetters([
      'axiosParamData'
    ]),
  },

  watch: {
    dialog(v) {
      if (!v) {
        this.resetData()
      }
    }
  },

  methods: {
    async confirm() {
      switch (this.step) {
        case 1:
          if (!this.selectType.length) {
            return this.errorMsg = '請至少選擇一項'
          } else {
            this.errorMsg = ''
          }
          this.loading = true
          try {
            const count = await this.submitPastAiResponse();
            this.title = `您即將送出 ${count} 筆AI回覆，送出後若要修改，會需要每筆手動操作。`;
            this.step = 2;
          } catch (error) {
            console.error('送出失敗：', error);
            this.$notify.error(String(error));
          } finally {
            this.loading = false
          }
          break;
        case 2:
          this.loading = true
          try {
            await this.submitPastAiResponse('prod');

            if (this.selectType.includes(2)) {
              this.$notify.info('送出成功，google 評價回覆需要一段時間，請稍後...');
            } else {
              this.$notify.success('送出成功');
            }
            this.dialog = false
            this.resetData()
          } catch (error) {
            console.error('操作失敗：', error);
            this.$notify.error(String(error));
          } finally {
            this.loading = false
          }
          break;
      }
    },
    async submitPastAiResponse(mode = 'dev') {
      const data = {
        mode,
        ...this.axiosParamData,
        generate_type: this.selectType
      };
      try {
        if (mode === 'dev') {
          const res = await submitPastAiResponseAPI(data);
          return res.data?.count;
        } else {
          submitPastAiResponseAPI(data).catch(error => {
            console.error('生成API請求失敗：', error);
          });
        }
      } catch (error) {
        console.error('送出API請求失敗：', error);
        const errorMsg = error?.response?.data?.messages || this.$t('GENERAL.oops');
        throw new Error(errorMsg);
      }
    },
    resetData() {
      this.step = this.$options.data().step
      this.title = this.$options.data().title
      this.selectType = this.$options.data().selectType
      this.errorMsg = this.$options.data().errorMsg
    }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
